'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".DetailsCard-module_container__3D6yT{align-items:center;flex-direction:row;text-align:left;width:100%}.DetailsCard-module_vertical__hpHZK{flex-direction:column;text-align:center}.DetailsCard-module_attributesContainer__DgVT8{align-items:flex-start;flex-direction:column}@container (max-width: 300px){.DetailsCard-module_container__3D6yT{flex-direction:column}}";
var styles = {"container":"DetailsCard-module_container__3D6yT","vertical":"DetailsCard-module_vertical__hpHZK","attributesContainer":"DetailsCard-module_attributesContainer__DgVT8"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
